








export default {
	name: 'currency',
	props: {
		value: {
			//type: Number, TODO: corregir pq viene string
			required: true,
		},
		coin: {
			type: String,
			default: 'ARS',
		},
		size: {
			type: String,
			default: '25',
		},
		signo: {
			type: String,
			required: false,
		},
	},
	computed: {
		currency() {
			return this.signo;
		},
		int() {
			var formatter = new Intl.NumberFormat('es-AR', {
				style: 'decimal',
				currency: this.coin,
				maximumFractionDigits: 0,
				minimumFractionDigits: 0,
			});
			return formatter.format(Math.trunc(this.value));
		},
		decimal() {
			var formatter = new Intl.NumberFormat('es-AR', {
				style: 'currency',
				currency: this.coin,
				minimumFractionDigits: 2,
			});

			let tmp = formatter.format(this.value);
			return tmp.substr(tmp.length - 3);
		},
	},
};
